import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayFeature,
} from '@packages/tracking/src/types/events';

const data = {
  category: 'AI-Fazit',
  label: 'Kundenbewertungen',
};

/**
 * Hook to track events related to the AI summary.
 */
export const useAiSummaryTracking = () => {
  const dispatchTracking = useTracking();

  /**
   * Tracks the display of the AI summary.
   */
  const trackGlycerinDisplayFeature = () => {
    dispatchTracking<GTMEventGlycerinDisplayFeature>({
      event: 'DisplayFeature',
      DisplayFeatureData: data,
    });
  };

  /**
   * Tracks the click on the AI summary button.
   */
  const trackGlycerinAIRatingClick = ({
    detail,
  }: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'detail'>) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        ...data,
        detail,
      },
    });
  };

  return { trackGlycerinDisplayFeature, trackGlycerinAIRatingClick };
};
